/* Northsheep (owner 3 Nov 2026): variant buttons that are sold out for the current choice are hidden. Streamline's
   VariantAvailability already knows which values are sold out but only disables them in dropdowns; this wraps its
   enableVariantOption. If the chosen value gets hidden (e.g. after switching colour), the first available one is chosen.
   Made by audit/lt/hide_soldout.py. */
(function () {
  var VA = window.theme && theme.VariantAvailability;
  if (!VA || VA.prototype.nsHideSoldOut) return;
  var P = VA.prototype, orig = P.enableVariantOption;
  P.nsHideSoldOut = true;
  P.enableVariantOption = function (group, obj) {
    orig.call(this, group, obj);
    if (this.type === 'dropdown' || !group || !obj) return;
    var v = String(obj.value).replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');
    var box = group.querySelector('.variant-input[data-value="' + v + '"]');
    if (!box) return;
    box.style.display = obj.soldOut ? 'none' : '';
    var input = box.querySelector('input');
    if (obj.soldOut && input && input.checked) {
      setTimeout(function () {
        var boxes = group.querySelectorAll('.variant-input');
        for (var i = 0; i < boxes.length; i++) {
          if (boxes[i].style.display !== 'none') {
            var next = boxes[i].querySelector('input');
            if (next && !next.checked) next.click();
            return;
          }
        }
      }, 0);
    }
  };
  /* The pickers on the page may already be set up before this ran: re-announce the chosen first option once, so the
     theme recalculates (and this hides) - also when the page is restored from the back/forward cache. */
  function recheck() {
    document.querySelectorAll('[data-dynamic-variants-enabled] .variant-input-wrap[data-index="option1"] input:checked').forEach(function (i) {
      i.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  if (document.readyState === 'complete') recheck(); else window.addEventListener('load', recheck);
  window.addEventListener('pageshow', function (e) { if (e.persisted) recheck(); });
})();
